// extracted by mini-css-extract-plugin
module.exports = {"arrow":"tooltip_arrow__nl8Q1","bubble":"tooltip_bubble__yW7ss","invertedBubble":"tooltip_invertedBubble__Y5j0p","invertedArrow":"tooltip_invertedArrow__DDytb"};